import React from "react";
import CustomButton from "../../../../../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";

export default function ErrorModalContent({
    onEnd,
    text,
}: {
    onEnd: Function;
    text: string;
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.75rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                {text}
            </Typography>
            <CustomButton
                onClick={() => {
                    onEnd();
                }}
                label="Terminer"
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
